import {
  axiosInstanceSimuladao,
  KEY_LOGIN_SIMULADAO,
  KEY_TOKEN_SIMULADAO,
} from '../../../core/api/simuladaoAxios';
import { setLocalStorage } from '../../../core/commom/localStorage';
import { GetRankingResponseDto } from '../models/GetRankingResponseDto';
import { GetSimuladaoResultResponseDto } from '../models/GetResultResponseDto';
import { LoginSimuladaoRequestDto } from '../models/LoginSimuladaoRequestDto';
import { LoginSimuladaoResponseDto } from '../models/LoginSimuladaoResponseDto';
import { ReportQuestionRequestDto } from '../models/ReportQuestionRequestDto';
import {
  GetSISUCourseModalitiesResponseDto,
  SISUCourse,
} from '../models/SISUAnaliticsData.model';
import { SaveSISUInfosRequestDto } from '../models/SaveSISUInfosRequestDto';
import { SaveSimuladaoAnswerRequestDto } from '../models/SaveSimuladaoAnswerRequestDto';
import { SaveSimuladaoAnswerResponseDto } from '../models/SaveSimuladaoAnswerResponseDto';
import { StartSimuladaoRequestDto } from '../models/StartSimuladaoRequestDto';
import { VerifyIfAlreadyStartSimuladaoResponseDto } from '../models/VerifyIfAlreadyStartSimuladaoResponseDto';
import { IFeedbackAverages } from '../models/feedbackAverage';
import { FinishSimuladaoRequestDto } from '../models/finishSimuladaoRequestDto';
import { GetCurrentSimuladaoResponseDto } from '../models/getCurrentSimuladaoResponseDto';
import { GetActualSimuladaoResponseDto } from '../models/GetActualSimuladaoResponseDto';
import { ISubscribeToSimuladaoRequestDto } from '../models/SubscribeToSimuladaoRequestDto';
import axiosInstance from '../../../core/api/axios';
import { RequestAuthCodeDto } from '../models/RequestAuthCodeDto';
import { RequestAuthCodeResponseDto } from '../models/RequestAuthCodeResponseDto';
import { ValidateAuthCodeDto } from '../models/ValidateAuthCodeDto';
import { ValidateAuthCodeResponseDto } from '../models/ValidateAuthCodeResponseDto';
import { StudentSimulationsResponseDto } from '../models/StudentSimulationsResponseDto';
import { FeedbackAreaResponseDto } from '../models/FeedbackAreaResponseDto';
import { IQuestionDetailsResponseDto } from '../models/QuestionDetails.model';
import { MarkQuestionReviewedRequestDto } from '../models/MarkQuestionReviewedRequestDto';

export async function loginSimuladao(
  data: LoginSimuladaoRequestDto
): Promise<LoginSimuladaoResponseDto> {
  const response = await axiosInstanceSimuladao.post(
    `/simuladaoaprova/login`,
    data
  );

  if (response.data && response.data.simulation_access_token) {
    setLocalStorage(KEY_TOKEN_SIMULADAO, response.data.simulation_access_token);
    setLocalStorage(KEY_LOGIN_SIMULADAO, 'true');
  }

  return response.data;
}
                          
export async function subscribeToSimuladao(
  data: ISubscribeToSimuladaoRequestDto
): Promise<void> {
  try {
    const response = await axiosInstance.post(
      `/simuladaoaprova/matriculation`,
      data
    );
    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getCurrentSimuladao(): Promise<GetCurrentSimuladaoResponseDto> {
  try {
    const response = await axiosInstanceSimuladao.get(`/simuladaoaprova/`);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getActualSimuladao(): Promise<GetActualSimuladaoResponseDto> {
  const response = await axiosInstanceSimuladao.get(`/simuladaoaprova/current`);
  return response.data;
}

export async function startSimuladao({
  ranking,
  simulatedSlug,
  day,
}: StartSimuladaoRequestDto) {
  try {
    const response = await axiosInstanceSimuladao.post(
      `/simuladaoaprova/start?day=${day}`,
      {
        simulatedSlug,
        ranking,
      }
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function verifyIfAlreadyStartSimuladao(
  simulatedSlug: string,
  day: number
): Promise<VerifyIfAlreadyStartSimuladaoResponseDto> {
  try {
    const response = await axiosInstanceSimuladao.get(
      `/simuladaoaprova/${simulatedSlug}/verify/started?day=${day}`
    );
    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getSISUCourses(): Promise<SISUCourse[]> {
  try {
    const response = await axiosInstanceSimuladao.get(`/analytics-data/sisu`);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getSISUCourseModalities(
  sisuId: string
): Promise<GetSISUCourseModalitiesResponseDto> {
  try {
    const response = await axiosInstanceSimuladao.get(
      `/analytics-data/sisu/${sisuId}`
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function saveSISUInfos(
  params: SaveSISUInfosRequestDto
): Promise<void> {
  try {
    const response = await axiosInstanceSimuladao.post(
      `/simuladaoaprova/sisu`,
      params
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getSimulationAverages(
  slug: string
): Promise<IFeedbackAverages> {
  try {
    const { data } = await axiosInstanceSimuladao.get(
      `/simuladaoaprova/${slug}/average`
    );

    return data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getRankingCompact(
  slug: string
): Promise<GetRankingResponseDto> {
  try {
    const { data } = await axiosInstanceSimuladao.get(
      `/simuladaoaprova/${slug}/ranking`
    );

    return data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getRankingComplete(
  slug: string
): Promise<GetRankingResponseDto> {
  try {
    const { data } = await axiosInstanceSimuladao.get(
      `/simuladaoaprova/${slug}/ranking/complete`
    );

    return data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function saveSimuladaoAnswer(
  params: SaveSimuladaoAnswerRequestDto
): Promise<SaveSimuladaoAnswerResponseDto> {
  try {
    const response = await axiosInstanceSimuladao.post(
      `/simuladaoaprova/answer`,
      params
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function finishSimuladao(params: FinishSimuladaoRequestDto) {
  try {
    const response = await axiosInstanceSimuladao.post(
      `/simuladaoaprova/finish`,
      params
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function reportQuestion(
  params: ReportQuestionRequestDto
): Promise<void> {
  try {
    const response = await axiosInstanceSimuladao.post(
      `/simuladaoaprova/report`,
      params
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getSimuladaoResult(
  slug: string,
  day: number
): Promise<GetSimuladaoResultResponseDto | null> {
  try {
    const response = await axiosInstanceSimuladao.get(
      `/simuladaoaprova/${slug}/result`,
      {
        params: {
          day,
        },
      }
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function requestAuthCode(
  data: RequestAuthCodeDto
): Promise<RequestAuthCodeResponseDto> {
  try {
    const response = await axiosInstanceSimuladao.post(
      `/simuladaoaprova/auth/request-code`,
      data
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function validateAuthCode(
  data: ValidateAuthCodeDto
): Promise<ValidateAuthCodeResponseDto> {
  try {
    const response = await axiosInstanceSimuladao.post(
      `/simuladaoaprova/auth/validate-code`,
      data
    );

    if (response.data && response.data.simulation_access_token) {
      setLocalStorage(KEY_TOKEN_SIMULADAO, response.data.simulation_access_token);
      setLocalStorage(KEY_LOGIN_SIMULADAO, 'false');
    }

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getStudentSimulations(): Promise<StudentSimulationsResponseDto> {
  try {
    const response = await axiosInstanceSimuladao.get(
      `/simuladaoaprova/student/simulations`
    );
    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getSimuladaoBySlug(
  slug: string
): Promise<GetCurrentSimuladaoResponseDto> {
  try {
    const response = await axiosInstanceSimuladao.get(
      `/simuladaoaprova/result/${slug}`
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getFeedbackByArea(
  slug: string,
  area: string
): Promise<FeedbackAreaResponseDto> {
  try {
    const response = await axiosInstanceSimuladao.get(
      `/simuladaoaprova/${slug}/feedback/area/${area}`
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getQuestionDetails(
  simulationSlug: string,
  questionId: string,
  exercisesNumber: string
): Promise<IQuestionDetailsResponseDto> {
  try {
    const response = await axiosInstanceSimuladao.get(
      `/simuladaoaprova/${simulationSlug}/feedback/question/${questionId}/${exercisesNumber}`
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function markQuestionReviewed(
  params: MarkQuestionReviewedRequestDto
): Promise<void> {
  try {
    const response = await axiosInstanceSimuladao.put(
      `/simuladaoaprova/question/review`,
      params
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}
